import Sortable from "sortablejs";
import {FormField} from "../form-field/form-field";
import {GvfService} from "../../../gvf/js/gvf-service";
import {GvfUiService} from "../../../gvf/js/gvf-ui-service";

export class FormFieldModelSelector extends FormField{
    constructor(scope,$root){
        super(scope,$root);
        this.$input = null;
        this.$info = null;
        this.$value = null;
        this.$suggest = null;
    }

    addValue(id,noEvent){
        if(this.$root.data("multiple")){
            let newIds = id;
            if(!$.isArray(id)){
                newIds = [id];
            }

            let ids = [];
            if(this.$value.val()){
                ids = JSON.parse(this.$value.val());
            }

            for(let i in newIds){
                if(ids.indexOf(newIds[i])== -1){
                    ids.push(newIds[i]);
                }
            }
            this.setVal(JSON.stringify(ids),noEvent);
        }else{
            this.setVal(id,noEvent);
        }
    }

    removeValue(id,noEvent){
        if(this.$root.data("multiple") && id!==undefined){
            id = id.toString();
            let ids = [];
            if(this.$value.val()){
                ids = JSON.parse(this.$value.val());
            }
            let index = ids.indexOf(id);
            if(index== -1 && !isNaN(id)){
                index = ids.indexOf(parseInt(id));
            }
            if(index> -1){
                ids.splice(index,1);
            }
            this.setVal(ids.length>0?JSON.stringify(ids):null,noEvent);
        }
    }

    emptyValue(){
        this.$input.val("");
        this.setVal("");
    }

    setVal(value,noEvent){
        if(this.$root.data("multiple") && $.isArray(value)){
            value = JSON.stringify(value);
        }
        this.$value.val(value);
        if(this.$root.data("multiple")){
            value = value?JSON.parse(value):[];
        }
        this.$root.toggleClass("has-value",!!this.$value.val());
        this.$root.toggleClass("has-no-value",!this.$value.val());
        this.$info.addClass("is-loading");
        GvfService.endpoint(
            this.$root.data("endpoint")+"/get-info",
            {
                model: this.$root.data("model"),
                value: value,
                multiple: this.$root.data("multiple"),
                editable: this.$root.hasClass("is-editable"),
                fieldData: this.$root.data()
            }
        ).then(
            (resp)=>{
                this.$info.html(resp.html);
                this.$info.find(this.scope+"__item-remove").click(
                    (ev)=>{
                        ev.preventDefault();
                        this.removeValue($(ev.currentTarget).data("id"));
                    }
                );
                this.$info.find(this.scope+"__empty").click(
                    (ev)=>{
                        ev.preventDefault();
                        this.emptyValue();
                    }
                );
                GvfUiService.init(this.$info);
            }
        ).finally(
            ()=>{
                this.$info.removeClass("is-loading");
            }
        );
        if(!noEvent){
            this.$root.trigger("formField:changeVal");
        }
    }

    getVal(){
        if(this.$value.val()){
            try{
                return JSON.parse(this.$value.val());
            }catch(e){ //might be a plain string value (char id for example)
                return this.$value.val();
            }
        }else{
            return null;
        }
    }

    /**
     * Shows suggestions
     * @param offset?
     */
    searchItems(offset){
        GvfService.endpoint(
            this.$root.data("endpoint")+"/search",
            {
                model: this.$root.data("model"),
                search: {q: this.$input.val()},
                fieldData: this.$root.data(),
                offset: offset?offset:0,
                formData: this.$root.closest("form").getValues()
            }
        ).then(
            (resp)=>{
                this.nextPage = false;
                this.$suggest.html($(resp.html));
                this.$suggest.show();
                this.$suggest.find(".is-item-row").click(
                    (ev)=>{
                        ev.preventDefault();
                        this.addValue($(ev.currentTarget).data("id"));
                        this.$suggest.hide();
                        this.$input.val("");
                    }
                ).mousedown(
                    (ev)=>{
                        ev.preventDefault();
                        ev.stopPropagation();
                    }
                );
                this.$suggest.find(".is-more-items").click(
                    (ev)=>{
                        ev.preventDefault();
                        this.nextPage = true;
                        this.searchItems($(ev.currentTarget).data("next-page"));
                    }
                ).mousedown(
                    (ev)=>{
                        ev.preventDefault();
                        ev.stopPropagation();
                    }
                );
            }
        );
    }

    ready(){
        super.ready();
        this.$input = this.findMember("input");
        this.$info = this.findMember("info");
        this.$value = this.findMember("value");
        this.$suggest = this.findMember("suggest");
        this.$root.find(this.scope+"__empty").click(
            (ev)=>{
                ev.preventDefault();
                this.emptyValue();
            }
        );

        this.$root.find(this.scope+"__toggle-inline").click(
            (ev)=>{
                ev.preventDefault();
                this.$root.toggleClass("is-showing-inline");
            }
        );

        this.$input.keyup(
            ()=>{
                GvfService.delay(500,"fieldmodelselectorkey").then(
                    ()=>{
                        this.searchItems();
                    }
                );
            }
        ).keydown(
            (ev)=>{
                const codeK = ev.keyCode || ev.which;
                if(codeK==13){ //intro
                    ev.preventDefault();
                }
            }
        ).blur(
            ()=>{
                if(!this.nextPage){
                    this.$suggest.hide();
                }
            }
        ).on("focus click",
            ()=>{
                this.$suggest.show();
            }
        );

        //initial load
        if(this.$value.val() && this.$info.html()==""){
            this.setVal(this.$value.val(),true);
        }
    }
}

